import { truncateLabel } from "../../../../utils/textPresentation.js";

export function fillSelect(selectEl, placeholderText, items) {
    if (!selectEl) return;

    selectEl.innerHTML = "";

    const ph = document.createElement("option");
    ph.value = "";
    ph.textContent = placeholderText;
    ph.title = placeholderText;
    ph.selected = true;
    selectEl.appendChild(ph);

    (items || []).forEach((item) => {
        const fullLabel = String(item.name ?? "");
        const opt = document.createElement("option");
        opt.value = String(item.id);
        opt.textContent = truncateLabel(fullLabel, 32);
        opt.title = fullLabel;
        selectEl.appendChild(opt);
    });

    const selected = selectEl.options?.[selectEl.selectedIndex];
    selectEl.title = selected?.title?.trim?.() || selected?.textContent?.trim() || "";
}
